"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("styled-components"),r=require("../styles.js");const o=e.css`
    ${r=>{return o=null==r?void 0:r.theme,e.css`
        --header-price-color-base: var(
            --header-price-color,
            var(
                --component-accent-color-base,
                ${null===(s=null===(l=null==o?void 0:o.colors)||void 0===l?void 0:l.primary)||void 0===s?void 0:s.default}
            )
        );
    `;var o,l,s}}
    ${r.addChildVerticalSpace("14px")}
    .pricing {
        color: var(--header-price-color-base);
        font-weight: 600;
    }
`;exports.default=o,exports.styles=o;
//# sourceMappingURL=styles.js.map
